<template>
  <div
    class="toast"
    :class="[
      { show: alert?.type == 'error' || alert?.type == 'success' || alert?.type == 'info' },
      alert?.type
    ]"
    :type="alert?.type"
    data-cy="app-alert"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex flex-wrap">
      <div class="d-flex" style="flex: 1">
        <div class="toast-body" style="flex: 1">
          {{ alert?.message }}
        </div>
        <button type="button" aria-label="Close" @click="close"></button>
      </div>
      <div class="progress-line-con" v-if="alert?.time">
        <div class="progress-line" :style="{ animation: `width-fill ${alert.time}s linear` }"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useAlertsStore } from "@/stores/alerts";
const alertStore = useAlertsStore();

const props = defineProps({
  alert: Object
});

function close(event: MouseEvent) {
  event.stopImmediatePropagation();
  alertStore.removeAlert(props.alert);
}
</script>

<style lang="scss">
@keyframes width-fill {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.progress-line-con {
  height: 5px;
  width: 100%;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  overflow: hidden;
}
.progress-line {
  height: 5px;
  background-color: rgba(255, 255, 255, 0.7);
}

.error {
  .progress-line {
    background-color: rgba(255, 255, 255, 0.7);
  }
}

.info {
  .progress-line {
    background-color: rgba(255, 255, 255, 0.7);
  }
}
.toast {
  z-index: 9999;
}
</style>
